import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    &,
    &:before,
    &:after {
      box-sizing: inherit;
    }
  }
  :focus {
    outline: 0;
  }
  ul {
    list-style: none;
  }
  strong {
    font-weight: ${props => props.theme.font.weight.bold};
  }
  /* Layout */
  html {
    box-sizing: border-box;
    font-size: ${props => props.theme.font.scale};
    font-family: ${props => (props.theme.locale.dir === "rtl" ? "URW Geometric Arabic" : "Averta Std PE")};
    /* Changes for html and av-player and av-player-mini if player is visible */
    &.isMiniPlayerVisible {
      height: 100%;
      #av-player-mini {
        display: block;
      }
    }
    &.isPlayerVisible {
      height: 100%;
      #av-player {
        display: block;
      }
    }
  }
  body {
    overflow: hidden;
    /* Changes if player is visible */
    .isPlayerVisible & {
      height: 100%;
      transform: translateZ(0);
       background-color: ${props => props.theme.color.black};
      background-image: none;
    }

    .isMiniPlayerVisible & {
      height: 100%;
      ${props =>
        props.theme.locale.dir === "rtl"
          ? ``
          : `
        transform: translateZ(0);
        background-color: ${props => props.theme.color.black};
        //background-image: none;
      `}
    }
  }

  .blurred { filter: blur(.45rem); }
`;
